// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsReplenishedPropertyDto
 */
export interface IIsReplenishedPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsReplenishedPropertyDto
     */
    is_replenished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsReplenishedPropertyDto
     */
    is_replenished_state?: IIsReplenishedPropertyDtoIsReplenishedStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsReplenishedPropertyDtoIsReplenishedStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsReplenishedPropertyDto interface.
 */
export function instanceOfIIsReplenishedPropertyDto(value: object): value is IIsReplenishedPropertyDto {
    return true;
}

export function IIsReplenishedPropertyDtoFromJSON(json: any): IIsReplenishedPropertyDto {
    return IIsReplenishedPropertyDtoFromJSONTyped(json, false);
}

export function IIsReplenishedPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsReplenishedPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_replenished': json['is_replenished'] == null ? undefined : json['is_replenished'],
        'is_replenished_state': json['is_replenished_state'] == null ? undefined : json['is_replenished_state'],
    };
}

export function IIsReplenishedPropertyDtoToJSON(json: any): IIsReplenishedPropertyDto {
    return IIsReplenishedPropertyDtoToJSONTyped(json, false);
}

export function IIsReplenishedPropertyDtoToJSONTyped(value?: IIsReplenishedPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_replenished': value['is_replenished'],
        'is_replenished_state': value['is_replenished_state'],
    };
}

